/**
 * Returns the point of a mouse event
 */
export const getMouseEventPoint = (event) => {
    return {
        x: event.pageX,
        y: event.pageY
    };
};
